const storage = {
  set: (key, value) => window.localStorage.setItem(key, JSON.stringify(value)),
  get: (key) => JSON.parse(window.localStorage.getItem(key)),
  remove: (key) => window.localStorage.removeItem(key),
};

const checkUrlParam = (key, { expectedValue, remove = false } = {}) => {
  const url = new URL(window.location.href);
  const value = url.searchParams.get(key);

  if (remove && value !== null) {
    url.searchParams.delete(key);
    window.history.pushState({}, '', url.toString());
  }

  return expectedValue === undefined ? value : value === expectedValue;
};

const getUserStatus = (url) => {
  return fetch(url)
    .then((response) => response.json())
    .catch((err) => {
      console.error('Błąd podczas pobierania danych użytkownika:', err);
    });
};

const handleVoteResponse = (html) => {
  const vC = document.querySelector('.article__form');

  if (!vC) {
    return;
  }

  vC.classList.add('form--visible');
  vC.innerHTML = html;

  setTimeout(function () {
    vC.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }, 500);

  // Dezaktywuj przyciski głosowania
  document.querySelectorAll('.btn--vote').forEach((btn) => {
    btn.setAttribute('disabled', 'true');
  });
};

const sendVote = (url, data, form) => {
  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  };

  return fetch(url, fetchOptions)
    .then((response) => response.text())
    .catch((err) => {
      console.error('Błąd podczas wysyłania formularza:', err);
    });
};

const handleFormVoting = function () {
  const data = {};

  if (document.querySelectorAll('.form__wrapper').length > 0) {
    const form = document.querySelector('.form__wrapper');
    const fieldToValidate = form.querySelectorAll('.form-field');
    const fieldsNotMail = form.querySelectorAll(
      '.form-field:not([data-id="email"])'
    );
    const checkboxes = form.querySelectorAll('.form-checkbox');

    const validateInput = function (input) {
      input.addEventListener('input', function () {
        if (input.closest('fieldset').classList.contains('has-error')) {
          validateField(this, 2);
        }
      });
      input.addEventListener('change', function () {
        validateField(this, 2);
      });
    };

    fieldsNotMail.forEach(function (el) {
      validateInput(el);
    });

    checkboxes.forEach((el) => {
      el.addEventListener('change', function () {
        validateCheckbox(this);
      });
    });

    const submitBtns = form.querySelectorAll('.send-vote');

    // oddanie glosu - wysylanie danych z formularza
    submitBtns.forEach((btn) => {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        let formIsValid = true;
        data.selectedCar = form.querySelector('.form__selection h4').innerText;

        // walidacja formularza z danymi
        const voteWithOneLogin = btn.classList.contains('send-data');

        if (voteWithOneLogin) {
          fieldsNotMail.forEach((el) => {
            if (!validateField(el, 2)) {
              formIsValid = false;
            } else {
              data[el.getAttribute('data-id')] = el.value;
            }
          });

          checkboxes.forEach((el) => {
            if (!validateCheckbox(el)) {
              formIsValid = false;
            } else {
              data[el.getAttribute('data-id')] = el
                .closest('fieldset')
                .querySelector('label').innerText;
            }
          });
          data.button = 'vote_register';
        } else {
          // tutaj kod bez danych
          fieldToValidate.forEach((el) => {
            // jak cos ma error z fieldstovalidate to usun error
            el.closest('fieldset').classList.remove('has-error');
            el.closest('fieldset').setAttribute('data-error', '');
            if (el.value.trim().length > 0) {
              data[el.getAttribute('data-id')] = el.value;
            }
          });
          checkboxes.forEach((el) => {
            el.nextElementSibling.classList.remove('has-error');
            el.classList.remove('has-error');
            if (el.checked) {
              data[el.getAttribute('data-id')] = el
                .closest('fieldset')
                .querySelector('label').innerText;
            }
          });
          data.button = 'vote';
        }

        if (formIsValid && data.selectedCar) {
          createSpinner(form);

          const hasOLUser = checkUrlParam('oluser', {
            expectedValue: '1',
            remove: false,
          });

          const url = form.querySelector('form').dataset.url;
          const voteUrl = new URL(url);

          if (hasOLUser) {
            data.oluser = 1;
            voteUrl.searchParams.set('oluser', '1');
          }

          sendVote(voteUrl, data, form)
            .then((serverResponse) => {
              const isServerResponseOneLoginUrl =
                typeof serverResponse === 'string' &&
                serverResponse.startsWith('http');

              if (voteWithOneLogin && isServerResponseOneLoginUrl) {
                storage.set('postOneLoginData', data);

                if (serverResponse) {
                  window.location.href = serverResponse;
                }
              } else {
                handleVoteResponse(serverResponse);
              }
            })
            .catch(function (err) {
              console.error('Błąd:', err);
            });
        }
      });
    });
  }
};

const handlePostOneLoginVoting = () => {
  const form = document.querySelector('.form__wrapper');

  if (!form) {
    return;
  }

  const hasPostLogin = checkUrlParam('post_login', {
    expectedValue: '1',
    remove: true,
  });
  const hasOLUser = checkUrlParam('oluser', {
    expectedValue: '1',
    remove: false,
  });
  const postOneLoginData = storage.get('postOneLoginData');
  storage.remove('postOneLoginData');

  if (hasPostLogin && postOneLoginData) {
    postOneLoginData.post_login = 1;

    const url = form.querySelector('form').dataset.url;
    const voteUrl = new URL(url);

    if (hasOLUser) {
      postOneLoginData.oluser = 1;
      voteUrl.searchParams.set('oluser', '1');
    }

    sendVote(voteUrl, postOneLoginData, form)
      .then((response) => {
        console.log('Zagłosowano na : ' + postOneLoginData.selectedCar);
        handleVoteResponse(response);
      })
      .catch((err) => {
        console.error('Błąd podczas głosowania:', err);
      });
  }
};

const handleUserStatus = () => {
  const form = document.querySelector('.form__wrapper');

  if (!form) {
    return;
  }

  const statusUrl = form.querySelector('form').dataset.status;

  if (!statusUrl) {
    console.warn('Brak atrybutu data-status w formularzu!');
    return;
  }

  getUserStatus(statusUrl)
    .then(userStatus => {
      const { isLogged, voted, registered } = userStatus;

      if (voted) {
        const html = `          
          <div class="article__text">
              <div class="form__completed">
                  <h4>Dziękujemy!</h4>
                  <p>Dzisiejszy głos w tej kategorii został już oddany, zapraszamy ponownie jutro!</p>
               </div>
          </div>
        `;
        handleVoteResponse(html);

        return;
      }

      if (isLogged) {
        // @todo - nic nie rób?
      }

      if (registered) {
        // @todo - ukryj formularz i pokaż tylko przycisk głosuj?
      }
    });
};

// handleUserStatus();
handleFormVoting();
handlePostOneLoginVoting();
